import { create } from 'zustand';

import { ApiUtils } from '@shared/utils';
import { MiscApi } from '@shared/api/rest';

import { GetDictionariesResponse } from '@shared/api/rest/misc';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface DictionariesType {
  data?: GetDictionariesResponse;
  loading: boolean;
  error: string | null;
  get: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useGetDictionariesStore = create<DictionariesType>((set) => ({
  data: undefined,
  loading: false,
  error: null,

  get: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await MiscApi.getDictionaries(signal);
      set({ data: result?.data ?? undefined, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: undefined, loading: false, error: null }),
}));
